import { METRICS } from 'common/constants/constants';
import { getHighlightColors } from 'common/constants/_colors';
import _ from 'lodash';
import { ACCURACY_BUILDER } from './projects.consts';
import { getPmViewerFromStore } from 'components/hooks/PM/pm-provider-viewers';

export const getInvestmentColorsMap = ({ total_investment_counts = {} }) => {
  const investmentColors = getHighlightColors().filter(
    c => c !== METRICS.BUG_COLOR
  );
  const investmentKeys = total_investment_counts;

  const investmentColorsMap = [];
  Object.keys(investmentKeys)
    .filter(item => _.startCase(item) !== METRICS.BUG_STATE)
    .sort((a, b) => investmentKeys[a] - investmentKeys[b])
    .reverse()
    .forEach((key, idx) => {
      investmentColorsMap[key] = investmentColors[idx];
    });
  investmentColorsMap[_.toLower(METRICS.BUG_STATE)] = METRICS.BUG_COLOR;
  return investmentColorsMap;
};

export const getProjectTotalUnit = ({ isScrumProject }) =>
  isScrumProject ? '%' : '';

export const getDeliveryData = ({
  project,
  isScrumProject,
  deliveryType,
  totals
}) => {
  const pmViewer = getPmViewerFromStore();
  const planningKey =
    deliveryType === 'counts' ? 'planning_counts' : 'planning_story_points';

  if (!isScrumProject) {
    // calculate delta of Done value between currect iteration and prev iteration
    const prevPlanningKey =
      deliveryType === 'counts'
        ? 'prev_planning_counts'
        : 'prev_planning_story_points';

    const iterationsTotals = _.get(project, 'iterations', []).map(
      ({ [planningKey]: value, [prevPlanningKey]: prevValue }) => {
        const totalValue = _.get(value, 'done', 0);
        return Math.round(totalValue - _.get(prevValue, 'done', totalValue));
      }
    );

    const totalValue = Math.round(
      _.sum(iterationsTotals) / iterationsTotals.length
    );

    return [
      {
        icon: 'Speed',
        title: 'Throughput',
        info: `Done ${pmViewer.ticket.plural} per week measures the number of ${pmViewer.ticket.plural} or ${pmViewer.storyPoint.plural} the team delivers week over week. Elite teams are able to maintain and increase their velocity over time. Team velocity can help you predict delivery time and capacity.`,
        chartTitle: `Resolved ${pmViewer.ticket.plural}`,
        color: 'melrose',
        totalValue,
        totalSuffix: '',
        totalText: `Avg ${
          deliveryType === 'counts'
            ? pmViewer.ticket.plural
            : pmViewer.storyPoint.plural
        } per week`,
        iterationsTotals
      }
    ];
  }

  // calcualte from total values: planning accuracy [completed / planned] and capacity accuracy [(completed + added) / planned]
  const accuracyBuilder = Object.values(ACCURACY_BUILDER);

  const totalValues = accuracyBuilder.map(
    ({
      key,
      ranges,
      graphIcon,
      title,
      info,
      icon,
      subtitle,
      color,
      barType,
      dashStyle,
      totalsCalculation
    }) => {
      const total = totalsCalculation(totals);

      const iterationsTotals = project.iterations.map(
        ({ [planningKey]: iterationValues }) => {
          const iterationsTotal = totalsCalculation(iterationValues);
          return iterationsTotal;
        }
      );

      return {
        key,
        ranges,
        title,
        chartTitle: title,
        icon,
        info,
        graphIcon,
        subtitle,
        color,
        dashStyle,
        barType,
        totalValue: total >= 0 ? total : '-',
        totalSuffix: total > 0 ? '%' : '',
        totalText: title,
        iterationsTotals
      };
    }
  );

  return totalValues;
};
